import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Toast from './components/Toast.vue'

import './assets/css/global.css'

Vue.config.productionTip = false

/** 全局注册吐司提示框 */
const ToastConstructor = Vue.extend(Toast)
const toastInstance = new ToastConstructor().$mount()
document.body.appendChild(toastInstance.$el)

Vue.prototype.$toast = {
  show: (options) => toastInstance.show(options),
  close: () => toastInstance.closeToast()
}

/** 全局挂载滚动定位方法 */
Vue.prototype.$scrollToRefById = function (targetKey, options = {}, isId = false) {
  const defaultOptions = { behavior: 'smooth', block: 'start' }
  const finalOptions = { ...defaultOptions, ...options }
  let targetSection = null
  if (isId) {
    targetSection = document.getElementById(targetKey)
  } else {
    targetSection = this.$refs[targetKey]
  }
  if (targetSection) {
    targetSection.scrollIntoView(finalOptions)
  } else {
    console.error(`未找到元素：${targetKey}`)
  }
}

/** 回退到上一个页面 */
Vue.prototype.$goBack = function () {
  if (window.history.length <= 1) {
    this.$router.push('/')
  } else {
    window.history.back()
  }
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
